import { OperationData } from '../types/OperationData';

export const emptyOperationData: OperationData = {
  id: '',
  alias: '',
  type: '',
  date: '',
  comments: '',
  amount: 0,
  sharesCount: 0,
  className: '',
  from: 0,
  to: 0,
  premium: 0,
  partnerTransactions: [],
  showExpandButton: false,
};
